import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4b47f62b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ui-full" }
const _hoisted_2 = { class: "ant-row ui-espaco-campos" }
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_4 = {
  class: "",
  title: "São utilizados inflamáveis, solventes, tintas, resinas, colas e outros)? "
}
const _hoisted_5 = {
  key: 0,
  class: "ui-manual-preenchimento-texto"
}
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ui-campo-instrucao" }, "- Se sim, detalhar produtos:", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = { class: "ui-campo-instrucao" }
const _hoisted_10 = { key: 2 }
const _hoisted_11 = {
  class: "",
  title: "Observações"
}
const _hoisted_12 = { class: "ant-row ui-espaco-campos" }
const _hoisted_13 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_14 = {
  class: "",
  title: "O processo envolve o uso de borrachas, plásticos, resinas ou outros materiais combustíveis?"
}
const _hoisted_15 = {
  key: 0,
  class: "ui-manual-preenchimento-texto"
}
const _hoisted_16 = { key: 1 }
const _hoisted_17 = {
  class: "",
  title: "Observações"
}
const _hoisted_18 = { class: "ant-row ui-espaco-campos" }
const _hoisted_19 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_20 = {
  class: "",
  title: "Há processos térmicos ou a quente como soldas, corte a plasma, estufas, secadores ou fornos?"
}
const _hoisted_21 = {
  key: 0,
  class: "ui-manual-preenchimento-texto"
}
const _hoisted_22 = { key: 1 }
const _hoisted_23 = {
  class: "",
  title: "Observações"
}
const _hoisted_24 = { class: "ant-row ui-espaco-campos" }
const _hoisted_25 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_26 = {
  class: "",
  title: "A empresa utiliza caldeiras, reatores ou fornos industriais? "
}
const _hoisted_27 = {
  key: 0,
  class: "ui-manual-preenchimento-texto"
}
const _hoisted_28 = { key: 1 }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ui-campo-instrucao" }, "- Apontar tipo, combustível, pressão e registro de inspeções (NR13) para caldeiras:", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_31 = { class: "ui-campo-instrucao" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_33 = { class: "ui-campo-instrucao" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ui-campo-instrucao" }, "- Data(s) de emissão do(s) último(s) Laudo(s):", -1))
const _hoisted_36 = { key: 2 }
const _hoisted_37 = {
  class: "",
  title: "Observações"
}
const _hoisted_38 = { class: "ant-row ui-espaco-campos" }
const _hoisted_39 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_40 = {
  class: "",
  title: "A empresa utiliza processo de jateamento?"
}
const _hoisted_41 = {
  key: 0,
  class: "ui-manual-preenchimento-texto"
}
const _hoisted_42 = { key: 1 }
const _hoisted_43 = { class: "ui-campo-instrucao" }
const _hoisted_44 = { key: 2 }
const _hoisted_45 = {
  class: "",
  title: "Observações"
}
const _hoisted_46 = { class: "ant-row ui-espaco-campos" }
const _hoisted_47 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_48 = {
  class: "",
  title: "A empresa utiliza cabine de pintura?"
}
const _hoisted_49 = {
  key: 0,
  class: "ui-manual-preenchimento-texto"
}
const _hoisted_50 = { key: 1 }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ui-campo-instrucao" }, "- Qual o material de construção da cabine de pintura:", -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ui-campo-instrucao" }, "- Qual o tipo de luminárias dentro da cabine de pintura?:", -1))
const _hoisted_54 = { key: 2 }
const _hoisted_55 = {
  class: "",
  title: "Observações"
}
const _hoisted_56 = { class: "ant-row ui-espaco-campos" }
const _hoisted_57 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_58 = {
  class: "",
  title: "Existe geração de poeiras combustíveis (madeira, alumínio, plástico, pó de grão, etc.) em alguma fase da operação?"
}
const _hoisted_59 = {
  key: 0,
  class: "ui-manual-preenchimento-texto"
}
const _hoisted_60 = { key: 1 }
const _hoisted_61 = {
  class: "",
  title: "Observações"
}
const _hoisted_62 = { class: "ant-row ui-espaco-campos" }
const _hoisted_63 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_64 = {
  class: "",
  title: "Existe central de gás, linha de gás encanado ou cilindros em uso?"
}
const _hoisted_65 = {
  key: 0,
  class: "ui-manual-preenchimento-texto"
}
const _hoisted_66 = { key: 1 }
const _hoisted_67 = {
  class: "",
  title: "Observações"
}
const _hoisted_68 = { class: "ant-row ui-espaco-campos" }
const _hoisted_69 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_70 = {
  class: "",
  title: "São utilizadas empilhadeiras ou paleteiras na operação?"
}
const _hoisted_71 = {
  key: 0,
  class: "ui-manual-preenchimento-texto"
}
const _hoisted_72 = { key: 1 }
const _hoisted_73 = { class: "ui-campo-instrucao" }
const _hoisted_74 = { key: 2 }
const _hoisted_75 = {
  class: "",
  title: "Observações"
}
const _hoisted_76 = { class: "ant-row ui-espaco-campos" }
const _hoisted_77 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_78 = {
  class: "",
  title: "Se houver empilhadeiras/paleteiras elétricas, existe local específico e isolado para o carregamento das baterias?"
}
const _hoisted_79 = {
  key: 0,
  class: "ui-manual-preenchimento-texto"
}
const _hoisted_80 = { key: 1 }
const _hoisted_81 = {
  class: "",
  title: "Observações"
}
const _hoisted_82 = { class: "ant-row ui-espaco-campos" }
const _hoisted_83 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_84 = {
  class: "",
  title: "Existe heliponto no local?"
}
const _hoisted_85 = {
  key: 0,
  class: "ui-manual-preenchimento-texto"
}
const _hoisted_86 = { key: 1 }
const _hoisted_87 = {
  class: "",
  title: "Observações"
}
const _hoisted_88 = { class: "ant-row ui-espaco-campos" }
const _hoisted_89 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_90 = {
  class: "",
  title: "Existem bens depositados ou armazenados ao ar livre no local ou durante o processo?"
}
const _hoisted_91 = { key: 0 }
const _hoisted_92 = { class: "ui-campo-instrucao" }
const _hoisted_93 = { key: 1 }
const _hoisted_94 = {
  class: "",
  title: "Observações"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_icone = _resolveComponent("icone")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_card = _resolveComponent("card")!

  return (_openBlock(), _createBlock(_component_card, {
    titulo: "SEÇÃO 2 – PROCESSOS E RISCOS OPERACIONAIS",
    "class-titulo": 'ui-card-info-titulo-rope'
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_a_form, { layout: "vertical" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("label", _hoisted_4, [
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Apresentar este campo no relatório?"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_checkbox, {
                        checked: _ctx.computedSecao2.usaInflamaveisVisivel,
                        "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.computedSecao2.usaInflamaveisVisivel) = $event))
                      }, null, 8, ["checked"])
                    ]),
                    _: 1
                  }),
                  (_ctx.computedSecao2.usaInflamaveisVisivel)
                    ? (_openBlock(), _createBlock(_component_a_tooltip, {
                        key: 0,
                        placement: "top",
                        title: _ctx.computedSecao2.usaInflamaveisEnviarEmail
                            ? 'Remover do E-mail para Envio'
                            : 'Incluir no E-mail para Envio'
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_checkbox, {
                            checked: _ctx.computedSecao2.usaInflamaveisEnviarEmail,
                            "onUpdate:checked": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.computedSecao2.usaInflamaveisEnviarEmail) = $event)),
                            class: _normalizeClass(["ui-check-email", {
                                'ui-check-email-marcado': _ctx.computedSecao2.usaInflamaveisEnviarEmail
                            }])
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_icone, { nome: "email" })
                            ]),
                            _: 1
                          }, 8, ["checked", "class"])
                        ]),
                        _: 1
                      }, 8, ["title"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(" São utilizados inflamáveis, solventes, tintas, resinas, colas e outros? "),
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Manual de preenchimento"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        class: "ui-manual-preenchimento",
                        onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.alternarManualPreenchimento('usaInflamaveis')), ["prevent","stop"]))
                      }, [
                        _createVNode(_component_icone, { nome: "manual-preenchimento" })
                      ])
                    ]),
                    _: 1
                  }),
                  _createTextVNode(),
                  (_ctx.computedSecao2.usaInflamaveisVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 1,
                        checked: _ctx.computedSecao2.usaInflamaveis,
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.computedSecao2.usaInflamaveis = true))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Sim")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(),
                  (_ctx.computedSecao2.usaInflamaveisVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 2,
                        checked: !_ctx.computedSecao2.usaInflamaveis,
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.computedSecao2.usaInflamaveis = false))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Não")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.state.manuaisPreenchimento.usaInflamaveis)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.ManualPreenchimentoInspecao.usaInflamaveis), 1))
                  : _createCommentVNode("", true),
                ((_ctx.computedSecao2.usaInflamaveisVisivel && _ctx.computedSecao2.usaInflamaveis))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _hoisted_7,
                      _createVNode(_component_a_textarea, {
                        "auto-size": true,
                        value: _ctx.computedSecao2.detalheInflamaveis,
                        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.computedSecao2.detalheInflamaveis) = $event)),
                        disabled: _ctx.props.bloquearCampos
                      }, null, 8, ["value", "disabled"]),
                      _hoisted_8,
                      _createElementVNode("span", _hoisted_9, [
                        _createTextVNode("- A empresa possui um local destinado para guardar estes itens: "),
                        _createVNode(_component_a_checkbox, {
                          checked: _ctx.computedSecao2.possuiLocalArmazenamento,
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.computedSecao2.possuiLocalArmazenamento = true))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Sim")
                          ]),
                          _: 1
                        }, 8, ["checked"]),
                        _createTextVNode(),
                        _createVNode(_component_a_checkbox, {
                          checked: !_ctx.computedSecao2.possuiLocalArmazenamento,
                          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.computedSecao2.possuiLocalArmazenamento = false))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Não")
                          ]),
                          _: 1
                        }, 8, ["checked"])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.computedSecao2.usaInflamaveisVisivel)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createElementVNode("label", _hoisted_11, [
                        _createVNode(_component_a_tooltip, {
                          placement: "top",
                          title: "Apresentar este campo no relatório?"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_checkbox, {
                              checked: _ctx.computedSecao2.usaInflamaveisObservacoesVisivel,
                              "onUpdate:checked": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.computedSecao2.usaInflamaveisObservacoesVisivel) = $event))
                            }, null, 8, ["checked"])
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" Observações:")
                      ]),
                      (_ctx.computedSecao2.usaInflamaveisObservacoesVisivel)
                        ? (_openBlock(), _createBlock(_component_a_textarea, {
                            key: 0,
                            "auto-size": true,
                            value: _ctx.computedSecao2.usaInflamaveisObservacoes,
                            "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.computedSecao2.usaInflamaveisObservacoes) = $event)),
                            disabled: _ctx.props.bloquearCampos
                          }, null, 8, ["value", "disabled"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("label", _hoisted_14, [
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Apresentar este campo no relatório?"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_checkbox, {
                        checked: _ctx.computedSecao2.processoUsaMateriaisCombustiveisVisivel,
                        "onUpdate:checked": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.computedSecao2.processoUsaMateriaisCombustiveisVisivel) = $event))
                      }, null, 8, ["checked"])
                    ]),
                    _: 1
                  }),
                  (_ctx.computedSecao2.processoUsaMateriaisCombustiveisVisivel)
                    ? (_openBlock(), _createBlock(_component_a_tooltip, {
                        key: 0,
                        placement: "top",
                        title: _ctx.computedSecao2.processoUsaMateriaisCombustiveisEnviarEmail
                            ? 'Remover do E-mail para Envio'
                            : 'Incluir no E-mail para Envio'
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_checkbox, {
                            checked: _ctx.computedSecao2.processoUsaMateriaisCombustiveisEnviarEmail,
                            "onUpdate:checked": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.computedSecao2.processoUsaMateriaisCombustiveisEnviarEmail) = $event)),
                            class: _normalizeClass(["ui-check-email", {
                                'ui-check-email-marcado': _ctx.computedSecao2.processoUsaMateriaisCombustiveisEnviarEmail
                            }])
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_icone, { nome: "email" })
                            ]),
                            _: 1
                          }, 8, ["checked", "class"])
                        ]),
                        _: 1
                      }, 8, ["title"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(" O processo envolve o uso de borrachas, plásticos, resinas ou outros materiais combustíveis? "),
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Manual de preenchimento"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        class: "ui-manual-preenchimento",
                        onClick: _cache[12] || (_cache[12] = _withModifiers(($event: any) => (_ctx.alternarManualPreenchimento('processoUsaMateriaisCombustiveis')), ["prevent","stop"]))
                      }, [
                        _createVNode(_component_icone, { nome: "manual-preenchimento" })
                      ])
                    ]),
                    _: 1
                  }),
                  _createTextVNode(),
                  (_ctx.computedSecao2.processoUsaMateriaisCombustiveisVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 1,
                        checked: _ctx.computedSecao2.processoUsaMateriaisCombustiveis,
                        onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.computedSecao2.processoUsaMateriaisCombustiveis = true))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Sim")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(),
                  (_ctx.computedSecao2.processoUsaMateriaisCombustiveisVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 2,
                        checked: !_ctx.computedSecao2.processoUsaMateriaisCombustiveis,
                        onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.computedSecao2.processoUsaMateriaisCombustiveis = false))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Não")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.state.manuaisPreenchimento.processoUsaMateriaisCombustiveis)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_ctx.ManualPreenchimentoInspecao.processoUsaMateriaisCombustiveis), 1))
                  : _createCommentVNode("", true),
                (_ctx.computedSecao2.processoUsaMateriaisCombustiveisVisivel)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _createElementVNode("label", _hoisted_17, [
                        _createVNode(_component_a_tooltip, {
                          placement: "top",
                          title: "Apresentar este campo no relatório?"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_checkbox, {
                              checked: _ctx.computedSecao2.processoUsaMateriaisCombustiveisObservacoesVisivel,
                              "onUpdate:checked": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.computedSecao2.processoUsaMateriaisCombustiveisObservacoesVisivel) = $event))
                            }, null, 8, ["checked"])
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" Observações:")
                      ]),
                      (_ctx.computedSecao2.processoUsaMateriaisCombustiveisObservacoesVisivel)
                        ? (_openBlock(), _createBlock(_component_a_textarea, {
                            key: 0,
                            "auto-size": true,
                            value: _ctx.computedSecao2.processoUsaMateriaisCombustiveisObservacoes,
                            "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.computedSecao2.processoUsaMateriaisCombustiveisObservacoes) = $event)),
                            disabled: _ctx.props.bloquearCampos
                          }, null, 8, ["value", "disabled"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("label", _hoisted_20, [
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Apresentar este campo no relatório?"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_checkbox, {
                        checked: _ctx.computedSecao2.processosTermicosQuenteVisivel,
                        "onUpdate:checked": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.computedSecao2.processosTermicosQuenteVisivel) = $event))
                      }, null, 8, ["checked"])
                    ]),
                    _: 1
                  }),
                  (_ctx.computedSecao2.processosTermicosQuenteVisivel)
                    ? (_openBlock(), _createBlock(_component_a_tooltip, {
                        key: 0,
                        placement: "top",
                        title: _ctx.computedSecao2.processosTermicosQuenteEnviarEmail
                            ? 'Remover do E-mail para Envio'
                            : 'Incluir no E-mail para Envio'
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_checkbox, {
                            checked: _ctx.computedSecao2.processosTermicosQuenteEnviarEmail,
                            "onUpdate:checked": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.computedSecao2.processosTermicosQuenteEnviarEmail) = $event)),
                            class: _normalizeClass(["ui-check-email", {
                                'ui-check-email-marcado': _ctx.computedSecao2.processosTermicosQuenteEnviarEmail
                            }])
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_icone, { nome: "email" })
                            ]),
                            _: 1
                          }, 8, ["checked", "class"])
                        ]),
                        _: 1
                      }, 8, ["title"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(" Há processos térmicos ou a quente como soldas, corte a plasma, estufas, secadores ou fornos? "),
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Manual de preenchimento"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        class: "ui-manual-preenchimento",
                        onClick: _cache[19] || (_cache[19] = _withModifiers(($event: any) => (_ctx.alternarManualPreenchimento('processosTermicosQuente')), ["prevent","stop"]))
                      }, [
                        _createVNode(_component_icone, { nome: "manual-preenchimento" })
                      ])
                    ]),
                    _: 1
                  }),
                  _createTextVNode(),
                  (_ctx.computedSecao2.processosTermicosQuenteVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 1,
                        checked: _ctx.computedSecao2.processosTermicosQuente,
                        onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.computedSecao2.processosTermicosQuente = true))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Sim")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(),
                  (_ctx.computedSecao2.processosTermicosQuenteVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 2,
                        checked: !_ctx.computedSecao2.processosTermicosQuente,
                        onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.computedSecao2.processosTermicosQuente = false))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Não")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.state.manuaisPreenchimento.processosTermicosQuente)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(_ctx.ManualPreenchimentoInspecao.processosTermicosQuente), 1))
                  : _createCommentVNode("", true),
                (_ctx.computedSecao2.processosTermicosQuenteVisivel)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                      _createElementVNode("label", _hoisted_23, [
                        _createVNode(_component_a_tooltip, {
                          placement: "top",
                          title: "Apresentar este campo no relatório?"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_checkbox, {
                              checked: _ctx.computedSecao2.processosTermicosQuenteObservacoesVisivel,
                              "onUpdate:checked": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.computedSecao2.processosTermicosQuenteObservacoesVisivel) = $event))
                            }, null, 8, ["checked"])
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" Observações:")
                      ]),
                      (_ctx.computedSecao2.processosTermicosQuenteObservacoesVisivel)
                        ? (_openBlock(), _createBlock(_component_a_textarea, {
                            key: 0,
                            "auto-size": true,
                            value: _ctx.computedSecao2.processosTermicosQuenteObservacoes,
                            "onUpdate:value": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.computedSecao2.processosTermicosQuenteObservacoes) = $event)),
                            disabled: _ctx.props.bloquearCampos
                          }, null, 8, ["value", "disabled"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("label", _hoisted_26, [
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Apresentar este campo no relatório?"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_checkbox, {
                        checked: _ctx.computedSecao2.usaCaldeirasReatoresFornosVisivel,
                        "onUpdate:checked": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.computedSecao2.usaCaldeirasReatoresFornosVisivel) = $event))
                      }, null, 8, ["checked"])
                    ]),
                    _: 1
                  }),
                  (_ctx.computedSecao2.usaCaldeirasReatoresFornosVisivel)
                    ? (_openBlock(), _createBlock(_component_a_tooltip, {
                        key: 0,
                        placement: "top",
                        title: _ctx.computedSecao2.usaCaldeirasReatoresFornosEnviarEmail
                            ? 'Remover do E-mail para Envio'
                            : 'Incluir no E-mail para Envio'
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_checkbox, {
                            checked: _ctx.computedSecao2.usaCaldeirasReatoresFornosEnviarEmail,
                            "onUpdate:checked": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.computedSecao2.usaCaldeirasReatoresFornosEnviarEmail) = $event)),
                            class: _normalizeClass(["ui-check-email", {
                                'ui-check-email-marcado': _ctx.computedSecao2.usaCaldeirasReatoresFornosEnviarEmail
                            }])
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_icone, { nome: "email" })
                            ]),
                            _: 1
                          }, 8, ["checked", "class"])
                        ]),
                        _: 1
                      }, 8, ["title"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(" A empresa utiliza caldeiras, reatores ou fornos industriais? "),
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Manual de preenchimento"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        class: "ui-manual-preenchimento",
                        onClick: _cache[26] || (_cache[26] = _withModifiers(($event: any) => (_ctx.alternarManualPreenchimento('usaCaldeirasReatoresFornos')), ["prevent","stop"]))
                      }, [
                        _createVNode(_component_icone, { nome: "manual-preenchimento" })
                      ])
                    ]),
                    _: 1
                  }),
                  _createTextVNode(),
                  (_ctx.computedSecao2.usaCaldeirasReatoresFornosVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 1,
                        checked: _ctx.computedSecao2.usaCaldeirasReatoresFornos,
                        onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.computedSecao2.usaCaldeirasReatoresFornos = true))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Sim")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(),
                  (_ctx.computedSecao2.usaCaldeirasReatoresFornosVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 2,
                        checked: !_ctx.computedSecao2.usaCaldeirasReatoresFornos,
                        onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.computedSecao2.usaCaldeirasReatoresFornos = false))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Não")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.state.manuaisPreenchimento.usaCaldeirasReatoresFornos)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString(_ctx.ManualPreenchimentoInspecao.usaCaldeirasReatoresFornos), 1))
                  : _createCommentVNode("", true),
                ((_ctx.computedSecao2.usaCaldeirasReatoresFornosVisivel && _ctx.computedSecao2.usaCaldeirasReatoresFornos))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                      _hoisted_29,
                      _hoisted_30,
                      _createElementVNode("span", _hoisted_31, [
                        _createTextVNode("- Laudo de inspeção NR13? "),
                        _createVNode(_component_a_checkbox, {
                          checked: _ctx.computedSecao2.caldeirasPossuiLaudoNr13,
                          onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.computedSecao2.caldeirasPossuiLaudoNr13 = true))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Sim")
                          ]),
                          _: 1
                        }, 8, ["checked"]),
                        _createTextVNode(),
                        _createVNode(_component_a_checkbox, {
                          checked: !_ctx.computedSecao2.caldeirasPossuiLaudoNr13,
                          onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.computedSecao2.caldeirasPossuiLaudoNr13 = false))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Não")
                          ]),
                          _: 1
                        }, 8, ["checked"])
                      ]),
                      _hoisted_32,
                      _createElementVNode("span", _hoisted_33, [
                        _createTextVNode("- Equipamentos liberados para operação no laudo? "),
                        _createVNode(_component_a_checkbox, {
                          checked: _ctx.computedSecao2.caldeirasEquipamentosLiberados,
                          onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.computedSecao2.caldeirasEquipamentosLiberados = true))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Sim")
                          ]),
                          _: 1
                        }, 8, ["checked"]),
                        _createTextVNode(),
                        _createVNode(_component_a_checkbox, {
                          checked: !_ctx.computedSecao2.caldeirasEquipamentosLiberados,
                          onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.computedSecao2.caldeirasEquipamentosLiberados = false))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Não")
                          ]),
                          _: 1
                        }, 8, ["checked"])
                      ]),
                      _hoisted_34,
                      _hoisted_35,
                      _createVNode(_component_a_textarea, {
                        "auto-size": true,
                        value: _ctx.computedSecao2.caldeirasDataUltimoLaudo,
                        "onUpdate:value": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.computedSecao2.caldeirasDataUltimoLaudo) = $event)),
                        disabled: _ctx.props.bloquearCampos
                      }, null, 8, ["value", "disabled"])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.computedSecao2.usaCaldeirasReatoresFornosVisivel)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                      _createElementVNode("label", _hoisted_37, [
                        _createVNode(_component_a_tooltip, {
                          placement: "top",
                          title: "Apresentar este campo no relatório?"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_checkbox, {
                              checked: _ctx.computedSecao2.caldeirasObservacoesVisivel,
                              "onUpdate:checked": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.computedSecao2.caldeirasObservacoesVisivel) = $event))
                            }, null, 8, ["checked"])
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" Observações:")
                      ]),
                      (_ctx.computedSecao2.caldeirasObservacoesVisivel)
                        ? (_openBlock(), _createBlock(_component_a_textarea, {
                            key: 0,
                            "auto-size": true,
                            value: _ctx.computedSecao2.caldeirasObservacoes,
                            "onUpdate:value": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.computedSecao2.caldeirasObservacoes) = $event)),
                            disabled: _ctx.props.bloquearCampos
                          }, null, 8, ["value", "disabled"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("div", _hoisted_39, [
                _createElementVNode("label", _hoisted_40, [
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Apresentar este campo no relatório?"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_checkbox, {
                        checked: _ctx.computedSecao2.usaProcessoJateamentoVisivel,
                        "onUpdate:checked": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.computedSecao2.usaProcessoJateamentoVisivel) = $event))
                      }, null, 8, ["checked"])
                    ]),
                    _: 1
                  }),
                  (_ctx.computedSecao2.usaProcessoJateamentoVisivel)
                    ? (_openBlock(), _createBlock(_component_a_tooltip, {
                        key: 0,
                        placement: "top",
                        title: _ctx.computedSecao2.usaProcessoJateamentoEnviarEmail
                            ? 'Remover do E-mail para Envio'
                            : 'Incluir no E-mail para Envio'
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_checkbox, {
                            checked: _ctx.computedSecao2.usaProcessoJateamentoEnviarEmail,
                            "onUpdate:checked": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.computedSecao2.usaProcessoJateamentoEnviarEmail) = $event)),
                            class: _normalizeClass(["ui-check-email", {
                                'ui-check-email-marcado': _ctx.computedSecao2.usaProcessoJateamentoEnviarEmail
                            }])
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_icone, { nome: "email" })
                            ]),
                            _: 1
                          }, 8, ["checked", "class"])
                        ]),
                        _: 1
                      }, 8, ["title"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(" A empresa utiliza processo de jateamento? "),
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Manual de preenchimento"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        class: "ui-manual-preenchimento",
                        onClick: _cache[38] || (_cache[38] = _withModifiers(($event: any) => (_ctx.alternarManualPreenchimento('usaProcessoJateamento')), ["prevent","stop"]))
                      }, [
                        _createVNode(_component_icone, { nome: "manual-preenchimento" })
                      ])
                    ]),
                    _: 1
                  }),
                  _createTextVNode(),
                  (_ctx.computedSecao2.usaProcessoJateamentoVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 1,
                        checked: _ctx.computedSecao2.usaProcessoJateamento,
                        onClick: _cache[39] || (_cache[39] = ($event: any) => (_ctx.computedSecao2.usaProcessoJateamento = true))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Sim")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(),
                  (_ctx.computedSecao2.usaProcessoJateamentoVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 2,
                        checked: !_ctx.computedSecao2.usaProcessoJateamento,
                        onClick: _cache[40] || (_cache[40] = ($event: any) => (_ctx.computedSecao2.usaProcessoJateamento = false))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Não")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.state.manuaisPreenchimento.usaProcessoJateamento)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_41, _toDisplayString(_ctx.ManualPreenchimentoInspecao.usaProcessoJateamento), 1))
                  : _createCommentVNode("", true),
                ((_ctx.computedSecao2.usaProcessoJateamentoVisivel && _ctx.computedSecao2.usaProcessoJateamento))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                      _createElementVNode("span", _hoisted_43, [
                        _createTextVNode("- Qual o tipo? "),
                        _createVNode(_component_a_checkbox, {
                          checked: _ctx.computedSecao2.processoJateamentoManual,
                          "onUpdate:checked": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.computedSecao2.processoJateamentoManual) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Manual")
                          ]),
                          _: 1
                        }, 8, ["checked"]),
                        _createTextVNode(),
                        _createVNode(_component_a_checkbox, {
                          checked: _ctx.computedSecao2.processoJateamentoAutomatico,
                          "onUpdate:checked": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.computedSecao2.processoJateamentoAutomatico) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Automático")
                          ]),
                          _: 1
                        }, 8, ["checked"])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.computedSecao2.usaProcessoJateamentoVisivel)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                      _createElementVNode("label", _hoisted_45, [
                        _createVNode(_component_a_tooltip, {
                          placement: "top",
                          title: "Apresentar este campo no relatório?"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_checkbox, {
                              checked: _ctx.computedSecao2.processoJateamentoObservacoesVisivel,
                              "onUpdate:checked": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.computedSecao2.processoJateamentoObservacoesVisivel) = $event))
                            }, null, 8, ["checked"])
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" Observações:")
                      ]),
                      (_ctx.computedSecao2.processoJateamentoObservacoesVisivel)
                        ? (_openBlock(), _createBlock(_component_a_textarea, {
                            key: 0,
                            "auto-size": true,
                            value: _ctx.computedSecao2.processoJateamentoObservacoes,
                            "onUpdate:value": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.computedSecao2.processoJateamentoObservacoes) = $event)),
                            disabled: _ctx.props.bloquearCampos
                          }, null, 8, ["value", "disabled"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("div", _hoisted_47, [
                _createElementVNode("label", _hoisted_48, [
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Apresentar este campo no relatório?"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_checkbox, {
                        checked: _ctx.computedSecao2.possuiCabinePinturaVisivel,
                        "onUpdate:checked": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.computedSecao2.possuiCabinePinturaVisivel) = $event))
                      }, null, 8, ["checked"])
                    ]),
                    _: 1
                  }),
                  (_ctx.computedSecao2.possuiCabinePinturaVisivel)
                    ? (_openBlock(), _createBlock(_component_a_tooltip, {
                        key: 0,
                        placement: "top",
                        title: _ctx.computedSecao2.possuiCabinePinturaEnviarEmail
                            ? 'Remover do E-mail para Envio'
                            : 'Incluir no E-mail para Envio'
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_checkbox, {
                            checked: _ctx.computedSecao2.possuiCabinePinturaEnviarEmail,
                            "onUpdate:checked": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.computedSecao2.possuiCabinePinturaEnviarEmail) = $event)),
                            class: _normalizeClass(["ui-check-email", {
                                'ui-check-email-marcado': _ctx.computedSecao2.possuiCabinePinturaEnviarEmail
                            }])
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_icone, { nome: "email" })
                            ]),
                            _: 1
                          }, 8, ["checked", "class"])
                        ]),
                        _: 1
                      }, 8, ["title"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(" A empresa utiliza cabine de pintura? "),
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Manual de preenchimento"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        class: "ui-manual-preenchimento",
                        onClick: _cache[47] || (_cache[47] = _withModifiers(($event: any) => (_ctx.alternarManualPreenchimento('possuiCabinePintura')), ["prevent","stop"]))
                      }, [
                        _createVNode(_component_icone, { nome: "manual-preenchimento" })
                      ])
                    ]),
                    _: 1
                  }),
                  _createTextVNode(),
                  (_ctx.computedSecao2.possuiCabinePinturaVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 1,
                        checked: _ctx.computedSecao2.possuiCabinePintura,
                        onClick: _cache[48] || (_cache[48] = ($event: any) => (_ctx.computedSecao2.possuiCabinePintura = true))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Sim")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(),
                  (_ctx.computedSecao2.possuiCabinePinturaVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 2,
                        checked: !_ctx.computedSecao2.possuiCabinePintura,
                        onClick: _cache[49] || (_cache[49] = ($event: any) => (_ctx.computedSecao2.possuiCabinePintura = false))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Não")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.state.manuaisPreenchimento.possuiCabinePintura)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_49, _toDisplayString(_ctx.ManualPreenchimentoInspecao.possuiCabinePintura), 1))
                  : _createCommentVNode("", true),
                ((_ctx.computedSecao2.possuiCabinePinturaVisivel && _ctx.computedSecao2.possuiCabinePintura))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                      _hoisted_51,
                      _createVNode(_component_a_textarea, {
                        "auto-size": true,
                        value: _ctx.computedSecao2.cabinePinturaMaterialConstrucao,
                        "onUpdate:value": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.computedSecao2.cabinePinturaMaterialConstrucao) = $event)),
                        disabled: _ctx.props.bloquearCampos
                      }, null, 8, ["value", "disabled"]),
                      _hoisted_52,
                      _hoisted_53,
                      _createVNode(_component_a_textarea, {
                        "auto-size": true,
                        value: _ctx.computedSecao2.cabinePinturaTipoLuminarias,
                        "onUpdate:value": _cache[51] || (_cache[51] = ($event: any) => ((_ctx.computedSecao2.cabinePinturaTipoLuminarias) = $event)),
                        disabled: _ctx.props.bloquearCampos
                      }, null, 8, ["value", "disabled"])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.computedSecao2.possuiCabinePinturaVisivel)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                      _createElementVNode("label", _hoisted_55, [
                        _createVNode(_component_a_tooltip, {
                          placement: "top",
                          title: "Apresentar este campo no relatório?"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_checkbox, {
                              checked: _ctx.computedSecao2.cabinePinturaObservacoesVisivel,
                              "onUpdate:checked": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.computedSecao2.cabinePinturaObservacoesVisivel) = $event))
                            }, null, 8, ["checked"])
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" Observações:")
                      ]),
                      (_ctx.computedSecao2.cabinePinturaObservacoesVisivel)
                        ? (_openBlock(), _createBlock(_component_a_textarea, {
                            key: 0,
                            "auto-size": true,
                            value: _ctx.computedSecao2.cabinePinturaObservacoes,
                            "onUpdate:value": _cache[53] || (_cache[53] = ($event: any) => ((_ctx.computedSecao2.cabinePinturaObservacoes) = $event)),
                            disabled: _ctx.props.bloquearCampos
                          }, null, 8, ["value", "disabled"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_56, [
              _createElementVNode("div", _hoisted_57, [
                _createElementVNode("label", _hoisted_58, [
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Apresentar este campo no relatório?"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_checkbox, {
                        checked: _ctx.computedSecao2.geraPoeiraCombustivelVisivel,
                        "onUpdate:checked": _cache[54] || (_cache[54] = ($event: any) => ((_ctx.computedSecao2.geraPoeiraCombustivelVisivel) = $event))
                      }, null, 8, ["checked"])
                    ]),
                    _: 1
                  }),
                  (_ctx.computedSecao2.geraPoeiraCombustivelVisivel)
                    ? (_openBlock(), _createBlock(_component_a_tooltip, {
                        key: 0,
                        placement: "top",
                        title: _ctx.computedSecao2.geraPoeiraCombustivelEnviarEmail
                            ? 'Remover do E-mail para Envio'
                            : 'Incluir no E-mail para Envio'
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_checkbox, {
                            checked: _ctx.computedSecao2.geraPoeiraCombustivelEnviarEmail,
                            "onUpdate:checked": _cache[55] || (_cache[55] = ($event: any) => ((_ctx.computedSecao2.geraPoeiraCombustivelEnviarEmail) = $event)),
                            class: _normalizeClass(["ui-check-email", {
                                'ui-check-email-marcado': _ctx.computedSecao2.geraPoeiraCombustivelEnviarEmail
                            }])
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_icone, { nome: "email" })
                            ]),
                            _: 1
                          }, 8, ["checked", "class"])
                        ]),
                        _: 1
                      }, 8, ["title"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(" Existe geração de poeiras combustíveis (madeira, alumínio, plástico, pó de grão, etc.) em alguma fase da operação? "),
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Manual de preenchimento"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        class: "ui-manual-preenchimento",
                        onClick: _cache[56] || (_cache[56] = _withModifiers(($event: any) => (_ctx.alternarManualPreenchimento('geraPoeiraCombustivel')), ["prevent","stop"]))
                      }, [
                        _createVNode(_component_icone, { nome: "manual-preenchimento" })
                      ])
                    ]),
                    _: 1
                  }),
                  _createTextVNode(),
                  (_ctx.computedSecao2.geraPoeiraCombustivelVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 1,
                        checked: _ctx.computedSecao2.geraPoeiraCombustivel,
                        onClick: _cache[57] || (_cache[57] = ($event: any) => (_ctx.computedSecao2.geraPoeiraCombustivel = true))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Sim")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(),
                  (_ctx.computedSecao2.geraPoeiraCombustivelVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 2,
                        checked: !_ctx.computedSecao2.geraPoeiraCombustivel,
                        onClick: _cache[58] || (_cache[58] = ($event: any) => (_ctx.computedSecao2.geraPoeiraCombustivel = false))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Não")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.state.manuaisPreenchimento.geraPoeiraCombustivel)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_59, _toDisplayString(_ctx.ManualPreenchimentoInspecao.geraPoeiraCombustivel), 1))
                  : _createCommentVNode("", true),
                (_ctx.computedSecao2.geraPoeiraCombustivelVisivel)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                      _createElementVNode("label", _hoisted_61, [
                        _createVNode(_component_a_tooltip, {
                          placement: "top",
                          title: "Apresentar este campo no relatório?"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_checkbox, {
                              checked: _ctx.computedSecao2.geraPoeiraCombustivelObservacoesVisivel,
                              "onUpdate:checked": _cache[59] || (_cache[59] = ($event: any) => ((_ctx.computedSecao2.geraPoeiraCombustivelObservacoesVisivel) = $event))
                            }, null, 8, ["checked"])
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" Observações:")
                      ]),
                      (_ctx.computedSecao2.geraPoeiraCombustivelObservacoesVisivel)
                        ? (_openBlock(), _createBlock(_component_a_textarea, {
                            key: 0,
                            "auto-size": true,
                            value: _ctx.computedSecao2.geraPoeiraCombustivelObservacoes,
                            "onUpdate:value": _cache[60] || (_cache[60] = ($event: any) => ((_ctx.computedSecao2.geraPoeiraCombustivelObservacoes) = $event)),
                            disabled: _ctx.props.bloquearCampos
                          }, null, 8, ["value", "disabled"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_62, [
              _createElementVNode("div", _hoisted_63, [
                _createElementVNode("label", _hoisted_64, [
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Apresentar este campo no relatório?"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_checkbox, {
                        checked: _ctx.computedSecao2.possuiCentralOuLinhaGasVisivel,
                        "onUpdate:checked": _cache[61] || (_cache[61] = ($event: any) => ((_ctx.computedSecao2.possuiCentralOuLinhaGasVisivel) = $event))
                      }, null, 8, ["checked"])
                    ]),
                    _: 1
                  }),
                  (_ctx.computedSecao2.possuiCentralOuLinhaGasVisivel)
                    ? (_openBlock(), _createBlock(_component_a_tooltip, {
                        key: 0,
                        placement: "top",
                        title: _ctx.computedSecao2.possuiCentralOuLinhaGasEnviarEmail
                            ? 'Remover do E-mail para Envio'
                            : 'Incluir no E-mail para Envio'
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_checkbox, {
                            checked: _ctx.computedSecao2.possuiCentralOuLinhaGasEnviarEmail,
                            "onUpdate:checked": _cache[62] || (_cache[62] = ($event: any) => ((_ctx.computedSecao2.possuiCentralOuLinhaGasEnviarEmail) = $event)),
                            class: _normalizeClass(["ui-check-email", {
                                'ui-check-email-marcado': _ctx.computedSecao2.possuiCentralOuLinhaGasEnviarEmail
                            }])
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_icone, { nome: "email" })
                            ]),
                            _: 1
                          }, 8, ["checked", "class"])
                        ]),
                        _: 1
                      }, 8, ["title"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(" Existe central de gás, linha de gás encanado ou cilindros em uso? "),
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Manual de preenchimento"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        class: "ui-manual-preenchimento",
                        onClick: _cache[63] || (_cache[63] = _withModifiers(($event: any) => (_ctx.alternarManualPreenchimento('possuiCentralOuLinhaGas')), ["prevent","stop"]))
                      }, [
                        _createVNode(_component_icone, { nome: "manual-preenchimento" })
                      ])
                    ]),
                    _: 1
                  }),
                  _createTextVNode(),
                  (_ctx.computedSecao2.possuiCentralOuLinhaGasVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 1,
                        checked: _ctx.computedSecao2.possuiCentralOuLinhaGas,
                        onClick: _cache[64] || (_cache[64] = ($event: any) => (_ctx.computedSecao2.possuiCentralOuLinhaGas = true))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Sim")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(),
                  (_ctx.computedSecao2.possuiCentralOuLinhaGasVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 2,
                        checked: !_ctx.computedSecao2.possuiCentralOuLinhaGas,
                        onClick: _cache[65] || (_cache[65] = ($event: any) => (_ctx.computedSecao2.possuiCentralOuLinhaGas = false))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Não")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.state.manuaisPreenchimento.possuiCentralOuLinhaGas)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_65, _toDisplayString(_ctx.ManualPreenchimentoInspecao.possuiCentralOuLinhaGas), 1))
                  : _createCommentVNode("", true),
                (_ctx.computedSecao2.possuiCentralOuLinhaGasVisivel)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                      _createElementVNode("label", _hoisted_67, [
                        _createVNode(_component_a_tooltip, {
                          placement: "top",
                          title: "Apresentar este campo no relatório?"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_checkbox, {
                              checked: _ctx.computedSecao2.possuiCentralOuLinhaGasObservacoesVisivel,
                              "onUpdate:checked": _cache[66] || (_cache[66] = ($event: any) => ((_ctx.computedSecao2.possuiCentralOuLinhaGasObservacoesVisivel) = $event))
                            }, null, 8, ["checked"])
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" Observações:")
                      ]),
                      (_ctx.computedSecao2.possuiCentralOuLinhaGasObservacoesVisivel)
                        ? (_openBlock(), _createBlock(_component_a_textarea, {
                            key: 0,
                            "auto-size": true,
                            value: _ctx.computedSecao2.possuiCentralOuLinhaGasObservacoes,
                            "onUpdate:value": _cache[67] || (_cache[67] = ($event: any) => ((_ctx.computedSecao2.possuiCentralOuLinhaGasObservacoes) = $event)),
                            disabled: _ctx.props.bloquearCampos
                          }, null, 8, ["value", "disabled"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_68, [
              _createElementVNode("div", _hoisted_69, [
                _createElementVNode("label", _hoisted_70, [
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Apresentar este campo no relatório?"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_checkbox, {
                        checked: _ctx.computedSecao2.usaEmpilhadeirasPaleteirasVisivel,
                        "onUpdate:checked": _cache[68] || (_cache[68] = ($event: any) => ((_ctx.computedSecao2.usaEmpilhadeirasPaleteirasVisivel) = $event))
                      }, null, 8, ["checked"])
                    ]),
                    _: 1
                  }),
                  (_ctx.computedSecao2.usaEmpilhadeirasPaleteirasVisivel)
                    ? (_openBlock(), _createBlock(_component_a_tooltip, {
                        key: 0,
                        placement: "top",
                        title: _ctx.computedSecao2.usaEmpilhadeirasPaleteirasEnviarEmail
                            ? 'Remover do E-mail para Envio'
                            : 'Incluir no E-mail para Envio'
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_checkbox, {
                            checked: _ctx.computedSecao2.usaEmpilhadeirasPaleteirasEnviarEmail,
                            "onUpdate:checked": _cache[69] || (_cache[69] = ($event: any) => ((_ctx.computedSecao2.usaEmpilhadeirasPaleteirasEnviarEmail) = $event)),
                            class: _normalizeClass(["ui-check-email", {
                                'ui-check-email-marcado': _ctx.computedSecao2.usaEmpilhadeirasPaleteirasEnviarEmail
                            }])
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_icone, { nome: "email" })
                            ]),
                            _: 1
                          }, 8, ["checked", "class"])
                        ]),
                        _: 1
                      }, 8, ["title"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(" São utilizadas empilhadeiras ou paleteiras na operação? "),
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Manual de preenchimento"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        class: "ui-manual-preenchimento",
                        onClick: _cache[70] || (_cache[70] = _withModifiers(($event: any) => (_ctx.alternarManualPreenchimento('usaEmpilhadeirasPaleteiras')), ["prevent","stop"]))
                      }, [
                        _createVNode(_component_icone, { nome: "manual-preenchimento" })
                      ])
                    ]),
                    _: 1
                  }),
                  _createTextVNode(),
                  (_ctx.computedSecao2.usaEmpilhadeirasPaleteirasVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 1,
                        checked: _ctx.computedSecao2.usaEmpilhadeirasPaleteiras,
                        onClick: _cache[71] || (_cache[71] = ($event: any) => (_ctx.computedSecao2.usaEmpilhadeirasPaleteiras = true))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Sim")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(),
                  (_ctx.computedSecao2.usaEmpilhadeirasPaleteirasVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 2,
                        checked: !_ctx.computedSecao2.usaEmpilhadeirasPaleteiras,
                        onClick: _cache[72] || (_cache[72] = ($event: any) => (_ctx.computedSecao2.usaEmpilhadeirasPaleteiras = false))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Não")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.state.manuaisPreenchimento.usaEmpilhadeirasPaleteiras)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_71, _toDisplayString(_ctx.ManualPreenchimentoInspecao.usaEmpilhadeirasPaleteiras), 1))
                  : _createCommentVNode("", true),
                ((_ctx.computedSecao2.usaEmpilhadeirasPaleteirasVisivel && _ctx.computedSecao2.usaEmpilhadeirasPaleteiras))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                      _createElementVNode("span", _hoisted_73, [
                        _createTextVNode("- Qual Tipo de Combustível: "),
                        _createVNode(_component_a_checkbox, {
                          checked: _ctx.computedSecao2.tipoCombustivelEmpilhadeirasPaleteirasGlp,
                          "onUpdate:checked": _cache[73] || (_cache[73] = ($event: any) => ((_ctx.computedSecao2.tipoCombustivelEmpilhadeirasPaleteirasGlp) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("GLP")
                          ]),
                          _: 1
                        }, 8, ["checked"]),
                        _createTextVNode(),
                        _createVNode(_component_a_checkbox, {
                          checked: _ctx.computedSecao2.tipoCombustivelEmpilhadeirasPaleteirasDiesel,
                          "onUpdate:checked": _cache[74] || (_cache[74] = ($event: any) => ((_ctx.computedSecao2.tipoCombustivelEmpilhadeirasPaleteirasDiesel) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Diesel")
                          ]),
                          _: 1
                        }, 8, ["checked"]),
                        _createTextVNode(),
                        _createVNode(_component_a_checkbox, {
                          checked: _ctx.computedSecao2.tipoCombustivelEmpilhadeirasPaleteirasGasolina,
                          "onUpdate:checked": _cache[75] || (_cache[75] = ($event: any) => ((_ctx.computedSecao2.tipoCombustivelEmpilhadeirasPaleteirasGasolina) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Gasolina")
                          ]),
                          _: 1
                        }, 8, ["checked"]),
                        _createTextVNode(),
                        _createVNode(_component_a_checkbox, {
                          checked: _ctx.computedSecao2.tipoCombustivelEmpilhadeirasPaleteirasLitio,
                          "onUpdate:checked": _cache[76] || (_cache[76] = ($event: any) => ((_ctx.computedSecao2.tipoCombustivelEmpilhadeirasPaleteirasLitio) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Bateria Lítio (Li-Ion)")
                          ]),
                          _: 1
                        }, 8, ["checked"]),
                        _createTextVNode(),
                        _createVNode(_component_a_checkbox, {
                          checked: _ctx.computedSecao2.tipoCombustivelEmpilhadeirasPaleteirasBateriaChumbo,
                          "onUpdate:checked": _cache[77] || (_cache[77] = ($event: any) => ((_ctx.computedSecao2.tipoCombustivelEmpilhadeirasPaleteirasBateriaChumbo) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Bateria Chumbo")
                          ]),
                          _: 1
                        }, 8, ["checked"])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.computedSecao2.usaEmpilhadeirasPaleteirasVisivel)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                      _createElementVNode("label", _hoisted_75, [
                        _createVNode(_component_a_tooltip, {
                          placement: "top",
                          title: "Apresentar este campo no relatório?"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_checkbox, {
                              checked: _ctx.computedSecao2.usaEmpilhadeirasPaleteirasObservacoesVisivel,
                              "onUpdate:checked": _cache[78] || (_cache[78] = ($event: any) => ((_ctx.computedSecao2.usaEmpilhadeirasPaleteirasObservacoesVisivel) = $event))
                            }, null, 8, ["checked"])
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" Observações:")
                      ]),
                      (_ctx.computedSecao2.usaEmpilhadeirasPaleteirasObservacoesVisivel)
                        ? (_openBlock(), _createBlock(_component_a_textarea, {
                            key: 0,
                            "auto-size": true,
                            value: _ctx.computedSecao2.usaEmpilhadeirasPaleteirasObservacoes,
                            "onUpdate:value": _cache[79] || (_cache[79] = ($event: any) => ((_ctx.computedSecao2.usaEmpilhadeirasPaleteirasObservacoes) = $event)),
                            disabled: _ctx.props.bloquearCampos
                          }, null, 8, ["value", "disabled"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_76, [
              _createElementVNode("div", _hoisted_77, [
                _createElementVNode("label", _hoisted_78, [
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Apresentar este campo no relatório?"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_checkbox, {
                        checked: _ctx.computedSecao2.localCarregamentoBateriasVisivel,
                        "onUpdate:checked": _cache[80] || (_cache[80] = ($event: any) => ((_ctx.computedSecao2.localCarregamentoBateriasVisivel) = $event))
                      }, null, 8, ["checked"])
                    ]),
                    _: 1
                  }),
                  (_ctx.computedSecao2.localCarregamentoBateriasVisivel)
                    ? (_openBlock(), _createBlock(_component_a_tooltip, {
                        key: 0,
                        placement: "top",
                        title: _ctx.computedSecao2.localCarregamentoBateriasEnviarEmail
                            ? 'Remover do E-mail para Envio'
                            : 'Incluir no E-mail para Envio'
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_checkbox, {
                            checked: _ctx.computedSecao2.localCarregamentoBateriasEnviarEmail,
                            "onUpdate:checked": _cache[81] || (_cache[81] = ($event: any) => ((_ctx.computedSecao2.localCarregamentoBateriasEnviarEmail) = $event)),
                            class: _normalizeClass(["ui-check-email", {
                                'ui-check-email-marcado': _ctx.computedSecao2.localCarregamentoBateriasEnviarEmail
                            }])
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_icone, { nome: "email" })
                            ]),
                            _: 1
                          }, 8, ["checked", "class"])
                        ]),
                        _: 1
                      }, 8, ["title"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(" Se houver empilhadeiras/paleteiras elétricas, existe local específico e isolado para o carregamento das baterias? "),
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Manual de preenchimento"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        class: "ui-manual-preenchimento",
                        onClick: _cache[82] || (_cache[82] = _withModifiers(($event: any) => (_ctx.alternarManualPreenchimento('localCarregamentoBaterias')), ["prevent","stop"]))
                      }, [
                        _createVNode(_component_icone, { nome: "manual-preenchimento" })
                      ])
                    ]),
                    _: 1
                  }),
                  _createTextVNode(),
                  (_ctx.computedSecao2.localCarregamentoBateriasVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 1,
                        checked: _ctx.computedSecao2.localCarregamentoBaterias,
                        onClick: _cache[83] || (_cache[83] = ($event: any) => (_ctx.computedSecao2.localCarregamentoBaterias = true))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Sim")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(),
                  (_ctx.computedSecao2.localCarregamentoBateriasVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 2,
                        checked: !_ctx.computedSecao2.localCarregamentoBaterias,
                        onClick: _cache[84] || (_cache[84] = ($event: any) => (_ctx.computedSecao2.localCarregamentoBaterias = false))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Não")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.state.manuaisPreenchimento.localCarregamentoBaterias)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_79, _toDisplayString(_ctx.ManualPreenchimentoInspecao.localCarregamentoBaterias), 1))
                  : _createCommentVNode("", true),
                (_ctx.computedSecao2.localCarregamentoBateriasVisivel)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                      _createElementVNode("label", _hoisted_81, [
                        _createVNode(_component_a_tooltip, {
                          placement: "top",
                          title: "Apresentar este campo no relatório?"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_checkbox, {
                              checked: _ctx.computedSecao2.localCarregamentoBateriasObservacoesVisivel,
                              "onUpdate:checked": _cache[85] || (_cache[85] = ($event: any) => ((_ctx.computedSecao2.localCarregamentoBateriasObservacoesVisivel) = $event))
                            }, null, 8, ["checked"])
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" Observações:")
                      ]),
                      (_ctx.computedSecao2.localCarregamentoBateriasObservacoesVisivel)
                        ? (_openBlock(), _createBlock(_component_a_textarea, {
                            key: 0,
                            "auto-size": true,
                            value: _ctx.computedSecao2.localCarregamentoBateriasObservacoes,
                            "onUpdate:value": _cache[86] || (_cache[86] = ($event: any) => ((_ctx.computedSecao2.localCarregamentoBateriasObservacoes) = $event)),
                            disabled: _ctx.props.bloquearCampos
                          }, null, 8, ["value", "disabled"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_82, [
              _createElementVNode("div", _hoisted_83, [
                _createElementVNode("label", _hoisted_84, [
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Apresentar este campo no relatório?"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_checkbox, {
                        checked: _ctx.computedSecao2.existeHelipontoVisivel,
                        "onUpdate:checked": _cache[87] || (_cache[87] = ($event: any) => ((_ctx.computedSecao2.existeHelipontoVisivel) = $event))
                      }, null, 8, ["checked"])
                    ]),
                    _: 1
                  }),
                  _createTextVNode(" Existe heliponto no local? "),
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Manual de preenchimento"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        class: "ui-manual-preenchimento",
                        onClick: _cache[88] || (_cache[88] = _withModifiers(($event: any) => (_ctx.alternarManualPreenchimento('existeHeliponto')), ["prevent","stop"]))
                      }, [
                        _createVNode(_component_icone, { nome: "manual-preenchimento" })
                      ])
                    ]),
                    _: 1
                  }),
                  _createTextVNode(),
                  (_ctx.computedSecao2.existeHelipontoVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 0,
                        checked: _ctx.computedSecao2.existeHeliponto,
                        onClick: _cache[89] || (_cache[89] = ($event: any) => (_ctx.computedSecao2.existeHeliponto = true))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Sim")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(),
                  (_ctx.computedSecao2.existeHelipontoVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 1,
                        checked: !_ctx.computedSecao2.existeHeliponto,
                        onClick: _cache[90] || (_cache[90] = ($event: any) => (_ctx.computedSecao2.existeHeliponto = false))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Não")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.state.manuaisPreenchimento.existeHeliponto)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_85, _toDisplayString(_ctx.ManualPreenchimentoInspecao.existeHeliponto), 1))
                  : _createCommentVNode("", true),
                (_ctx.computedSecao2.existeHelipontoVisivel)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
                      _createElementVNode("label", _hoisted_87, [
                        _createVNode(_component_a_tooltip, {
                          placement: "top",
                          title: "Apresentar este campo no relatório?"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_checkbox, {
                              checked: _ctx.computedSecao2.existeHelipontoObservacoesVisivel,
                              "onUpdate:checked": _cache[91] || (_cache[91] = ($event: any) => ((_ctx.computedSecao2.existeHelipontoObservacoesVisivel) = $event))
                            }, null, 8, ["checked"])
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" Observações:")
                      ]),
                      (_ctx.computedSecao2.existeHelipontoObservacoesVisivel)
                        ? (_openBlock(), _createBlock(_component_a_textarea, {
                            key: 0,
                            "auto-size": true,
                            value: _ctx.computedSecao2.existeHelipontoObservacoes,
                            "onUpdate:value": _cache[92] || (_cache[92] = ($event: any) => ((_ctx.computedSecao2.existeHelipontoObservacoes) = $event)),
                            disabled: _ctx.props.bloquearCampos
                          }, null, 8, ["value", "disabled"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_88, [
              _createElementVNode("div", _hoisted_89, [
                _createElementVNode("label", _hoisted_90, [
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Apresentar este campo no relatório?"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_checkbox, {
                        checked: _ctx.computedSecao2.bensArmazenadosArLivreVisivel,
                        "onUpdate:checked": _cache[93] || (_cache[93] = ($event: any) => ((_ctx.computedSecao2.bensArmazenadosArLivreVisivel) = $event))
                      }, null, 8, ["checked"])
                    ]),
                    _: 1
                  }),
                  (_ctx.computedSecao2.bensArmazenadosArLivreVisivel)
                    ? (_openBlock(), _createBlock(_component_a_tooltip, {
                        key: 0,
                        placement: "top",
                        title: _ctx.computedSecao2.bensArmazenadosArLivreEnviarEmail
                            ? 'Remover do E-mail para Envio'
                            : 'Incluir no E-mail para Envio'
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_checkbox, {
                            checked: _ctx.computedSecao2.bensArmazenadosArLivreEnviarEmail,
                            "onUpdate:checked": _cache[94] || (_cache[94] = ($event: any) => ((_ctx.computedSecao2.bensArmazenadosArLivreEnviarEmail) = $event)),
                            class: _normalizeClass(["ui-check-email", {
                                'ui-check-email-marcado': _ctx.computedSecao2.bensArmazenadosArLivreEnviarEmail
                            }])
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_icone, { nome: "email" })
                            ]),
                            _: 1
                          }, 8, ["checked", "class"])
                        ]),
                        _: 1
                      }, 8, ["title"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(" Existem bens depositados ou armazenados ao ar livre no local ou durante o processo? "),
                  (_ctx.computedSecao2.bensArmazenadosArLivreVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 1,
                        checked: _ctx.computedSecao2.bensArmazenadosArLivre,
                        onClick: _cache[95] || (_cache[95] = ($event: any) => (_ctx.computedSecao2.bensArmazenadosArLivre = true))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Sim")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(),
                  (_ctx.computedSecao2.bensArmazenadosArLivreVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 2,
                        checked: !_ctx.computedSecao2.bensArmazenadosArLivre,
                        onClick: _cache[96] || (_cache[96] = ($event: any) => (_ctx.computedSecao2.bensArmazenadosArLivre = false))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Não")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true)
                ]),
                ((_ctx.computedSecao2.bensArmazenadosArLivreVisivel && _ctx.computedSecao2.bensArmazenadosArLivre))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_91, [
                      _createElementVNode("span", _hoisted_92, [
                        _createTextVNode("- Esses bens são próprios ou de terceiros? "),
                        _createVNode(_component_a_checkbox, {
                          checked: _ctx.computedSecao2.bensArmazenadosArLivreProprios,
                          "onUpdate:checked": _cache[97] || (_cache[97] = ($event: any) => ((_ctx.computedSecao2.bensArmazenadosArLivreProprios) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Próprios")
                          ]),
                          _: 1
                        }, 8, ["checked"]),
                        _createTextVNode(),
                        _createVNode(_component_a_checkbox, {
                          checked: _ctx.computedSecao2.bensArmazenadosArLivreTerceiros,
                          "onUpdate:checked": _cache[98] || (_cache[98] = ($event: any) => ((_ctx.computedSecao2.bensArmazenadosArLivreTerceiros) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Terceiros")
                          ]),
                          _: 1
                        }, 8, ["checked"])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.computedSecao2.bensArmazenadosArLivreVisivel)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_93, [
                      _createElementVNode("label", _hoisted_94, [
                        _createVNode(_component_a_tooltip, {
                          placement: "top",
                          title: "Apresentar este campo no relatório?"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_checkbox, {
                              checked: _ctx.computedSecao2.bensArmazenadosArLivreObservacoesVisivel,
                              "onUpdate:checked": _cache[99] || (_cache[99] = ($event: any) => ((_ctx.computedSecao2.bensArmazenadosArLivreObservacoesVisivel) = $event))
                            }, null, 8, ["checked"])
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" Observações:")
                      ]),
                      (_ctx.computedSecao2.bensArmazenadosArLivreObservacoesVisivel)
                        ? (_openBlock(), _createBlock(_component_a_textarea, {
                            key: 0,
                            "auto-size": true,
                            value: _ctx.computedSecao2.bensArmazenadosArLivreObservacoes,
                            "onUpdate:value": _cache[100] || (_cache[100] = ($event: any) => ((_ctx.computedSecao2.bensArmazenadosArLivreObservacoes) = $event)),
                            disabled: _ctx.props.bloquearCampos
                          }, null, 8, ["value", "disabled"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}